<template>
  <el-tabs v-model="activeName" class="tabs">
    <el-tab-pane name="first" label="电脑端" class="mineCon">
      <div class="help">
        <p><strong>第一步：</strong>登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【个人主页】</span>
          ，即可进入【医生工作室】，在顶部菜单栏中点击<span class="orange">【预约管理】</span></p>
        <img src="../../../assets/doctorImg/chat_a.png" alt="" height="406">
        <p><strong>第二步：</strong>在【预约管理】列表中，找到要私信的用户，点击<span class="orange">【私聊TA】</span>跳转至聊天页面
        </p>
        <img src="../../../assets/doctorImg/chat_b.png" alt="" height="259">
        <p><strong>第三步：</strong>在【私聊】页面，可与用户进行线上交流<br/>
          左侧为聊天人员列表，点击可切换聊天<br/>
          右侧为聊天框
        </p>
        <img src="../../../assets/doctorImg/chat_c.png" alt="" height="627">
      </div>
    </el-tab-pane>
    <!--    <el-tab-pane name="second" label="移动端" class="mineCon">
          <div class="help">

          </div>
        </el-tab-pane>-->
  </el-tabs>
</template>

<script>
export default {
  name: "chatDoctor",
  data() {
    return {activeName: 'first'}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
